export const faqQuestionCategory = ['GENERAL', 'SUBSCRIPTION', 'OTHER'];
export const faqQuestionCategoryEnum = {
    GENERAL: 'Général',
    SUBSCRIPTION: 'Abonnement',
    OTHER: 'Autres sujets',
};
